<!-- Spinner -->

<!-- SubSubjects -->
<ng-template #subjects_template let-subjectNode="subjectNode" let-subPage="subPage" let-parentLocked="parentLocked">
  @if (subPage && !subjectNode.hidden) {
    <div class="list-group-container {{ subPage.themeColor }}">
      <div class="list-group-item">
        <a class="list-group-item-text"
          (click)="nodeSharedFacade.requestNodesByParentId(subjectNode.id)"
          [routerLink]="['/' , node.route, subjectNode.route]">{{ subPage.title }}</a>
        <medsurf-restricted-lock containerClass="pr-2" [node]="subjectNode"></medsurf-restricted-lock>
      </div>
    </div>
  }
</ng-template>

<!-- Content -->
@if ((appSharedFacade.page$(node.page) | async); as page) {
  <div class="card" [class.shadow-sm]="!showSubjects" [class.with-subjects]="showSubjects">
    <div class="card-header pb-0" id="headingOne">
      @if (mainHeading) {
        <h1 class="mb-0 d-flex justify-content-between">
          <span class="text-black page-title">{{ page.title }}</span>
          <medsurf-restricted-lock [node]="node"></medsurf-restricted-lock>
        </h1>
      }
      @if (!mainHeading) {
        <h2 class="mb-0 d-flex justify-content-between">
          <a class="text-black page-title"
            (click)="nodeSharedFacade.requestNodesByParentId(node.id)"
            [routerLink]="['/' , node.route]">
            {{ page.title }}
          </a>
          <medsurf-restricted-lock [node]="node"></medsurf-restricted-lock>
        </h2>
      }
    </div>
    <div class="card-body">
      @if (!mainHeading) {
        <medsurf-text-format
        [text]="page.description"></medsurf-text-format>
      }
      @else {
        <medsurf-text-format
        [text]="page.body"></medsurf-text-format>
      }
      @if (locked) {
        <div style="filter: blur(5px); pointer-events: none; user-select: none;">
          @for (child of node.children; track child; let idx = $index;) {
            <div class="list-group-container" [className]="themeColorList[idx % themeColorList.length].value">
              <div class="list-group-item">
                <span class="list-group-item-text">{{ themeColorList[idx % themeColorList.length].name }} Platzhalter</span>
              </div>
            </div>
          }
        </div>
      }
      @if (showSubjects && (!node.restricted || !locked)) {
        @if ((nodeSharedFacade.nodeByIds$(node.children) | async) | sortBy_shared:'asc':'position'; as subjectNodes) {
          @if (subjectNodes !== undefined) {
          } @else {
            <div class="d-flex justify-content-center m-2">
              <div class="spinner-border"></div>
            </div>
          }
          @for (subjectNode of subjectNodes; track subjectNode) {
            <ng-container *ngTemplateOutlet="subjects_template;context:{
              subjectNode: subjectNode,
              subPage: (appSharedFacade.page$(subjectNode.page) | async),
              parentLocked: locked}">
            </ng-container>
          }
        }
      }
      @if (!showSubjects && !locked) {
        <button href="#" class="mdsf-btn mdsf-btn-primary card-action" [routerLink]="['/' , node.route]" translate="open"></button>
      }
    </div>
  </div>
} @else {
  <div class="d-flex justify-content-center m-2">
    <div class="spinner-border"></div>
  </div>
}
